<div class="weather-forecast-container">
  <div class="weather-forecast-header">
    <h2 class="weather-forecast-title">3 Day - Weather Forecast</h2>
    <button class="minimize-btn" (click)="onDismiss()">
      <span class="minimize-icon">−</span>
    </button>
  </div>

  <div *ngIf="isLoading" class="weather-forecast-loading">
    <div class="spinner"></div>
  </div>

  <div *ngIf="!isLoading" class="weather-forecast-cards">
    <div *ngFor="let forecast of forecasts" class="forecast-card">
      <div class="forecast-day">{{ forecast.dayName }}</div>
      <div class="forecast-date">{{ forecast.date }}</div>
      
      <img class="forecast-weather-icon" [src]="'weather-forecast-assets/' + forecast.icon" alt="Weather icon" />
      
      <hr class="divider" />
      
      <div class="forecast-row">
        <img class="forecast-icon icon-blue" src="weather-forecast-assets/mintemp.svg" alt="Min temp" />
        <span class="forecast-label">Min:</span>
        <span class="forecast-value">{{ forecast.minTemp }}</span>
      </div>
      
      <hr class="divider" />
      
      <div class="forecast-row">
        <img class="forecast-icon icon-red" src="weather-forecast-assets/maxtemp.svg" alt="Max temp" />
        <span class="forecast-label">Max:</span>
        <span class="forecast-value">{{ forecast.maxTemp }}</span>
      </div>
      
      <hr class="divider" />
      
      <div class="forecast-row">
        <img class="forecast-icon icon-lightblue" src="weather-forecast-assets/wind.svg" alt="Wind" />
        <span class="forecast-label">Wind:</span>
        <span class="forecast-value">{{ forecast.wind }}</span>
      </div>
      
      <hr class="divider" />
      
      <div class="forecast-row">
        <img class="forecast-icon" src="weather-forecast-assets/winddir.svg" alt="Wind direction" />
        <span class="forecast-label">Dir:</span>
        <span class="forecast-value">{{ forecast.windDir }}</span>
      </div>
      
      <hr class="divider" />
      
      <div class="forecast-row">
        <img class="forecast-icon icon-royalblue" src="weather-forecast-assets/waterdrop.svg" alt="Rain" />
        <span class="forecast-label">Rain:</span>
        <span class="forecast-value">{{ forecast.rain }}</span>
      </div>
      
      <hr class="divider" />
      
      <div class="forecast-row">
        <img class="forecast-icon icon-green" src="weather-forecast-assets/evapotranspiration.svg" alt="ET" />
        <span class="forecast-label">ET:</span>
        <span class="forecast-value">{{ forecast.et }}</span>
      </div>
    </div>
  </div>
</div>
